export const actorsList = [
  {
    id: "a1",
    name: "筱田优",
    photo:
      "https://readdy.ai/api/search-image?query=Elegant%20portrait%20of%20a%20young%20Asian%20woman%20with%20calm%20confident%20expression%2C%20soft%20indigo%20studio%20background%20with%20warm%20amber%20rim%20light%2C%20refined%20editorial%20celebrity%20photography&width=600&height=800&seq=actor-c01&orientation=portrait",
    role: "演员 / 品牌主理人",
    bio: "以细腻而有力量的表演受到关注，代表作涵盖电影与电视剧，善于诠释内心复杂的女性角色。",
    intro: [
      "筱田优，演员，品牌主理人。出道以来以稳定而富有层次的表演受到业内与观众的关注。",
      "她擅长通过细微的表情与肢体语言传递情绪，在《无声告白》《长夜将尽》《春山可望》等作品中塑造了多个令人印象深刻的角色。",
      "除表演之外，她也参与作品的策划与制作，致力于推动更具质感的影视表达。",
    ],
    workIds: ["w1", "w2", "w3", "w4", "w5", "w6", "w7", "w8", "w9"],
    relatedNewsIds: ["n1", "n2", "n3", "n7", "n10"],
  },
  {
    id: "a2",
    name: "林澈",
    photo:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Asian%20man%20with%20thoughtful%20expression%2C%20soft%20indigo%20gradient%20background%20with%20warm%20light%20from%20the%20side%2C%20clean%20editorial%20celebrity%20photography&width=600&height=800&seq=actor-c02&orientation=portrait",
    role: "演员",
    bio: "实力派男演员，与筱田优多次合作，擅长塑造沉稳内敛的人物。",
    intro: [
      "林澈，演员。以沉稳内敛的表演风格受到关注，与筱田优在《无声告白》《光年之外》等作品中有过多次合作。",
      "他注重角色内心的合理性，常通过大量前期准备去还原人物的行动逻辑。",
    ],
    workIds: ["w1", "w3", "w7"],
    relatedNewsIds: ["n2", "n4"],
  },
  {
    id: "a3",
    name: "苏晚",
    photo:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20graceful%20young%20Asian%20woman%20with%20soft%20smile%2C%20muted%20indigo%20background%20with%20gentle%20amber%20glow%2C%20elegant%20editorial%20celebrity%20photography&width=600&height=800&seq=actor-c03&orientation=portrait",
    role: "演员",
    bio: "文艺片常客，气质清冷，擅长诠释细腻的情感戏份。",
    intro: [
      "苏晚，演员。以文艺题材作品见长，气质清冷细腻，在多部影片中呈现了富有张力的人物关系。",
      "她与筱田优先后合作多部作品，两人的对手戏被认为极具化学反应。",
    ],
    workIds: ["w1", "w2", "w9"],
    relatedNewsIds: ["n4", "n7"],
  },
  {
    id: "a4",
    name: "江野",
    photo:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20rugged%20young%20Asian%20man%20with%20intense%20gaze%2C%20deep%20indigo%20shadowy%20background%20with%20a%20subtle%20warm%20highlight%2C%20dramatic%20editorial%20celebrity%20photography&width=600&height=800&seq=actor-c04&orientation=portrait",
    role: "演员",
    bio: "擅长犯罪与职场题材，表演富有爆发力。",
    intro: [
      "江野，演员。以犯罪悬疑与都市题材作品为人熟知，表演富有爆发力与层次。",
      "在《长夜将尽》《逆风局》中，他与筱田优的对手戏成为作品的看点之一。",
    ],
    workIds: ["w3", "w8"],
    relatedNewsIds: ["n1", "n6"],
  },
  {
    id: "a5",
    name: "温屿",
    photo:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20gentle%20young%20Asian%20woman%20with%20warm%20expression%2C%20soft%20cream%20and%20indigo%20background%2C%20natural%20lighting%2C%20refined%20editorial%20celebrity%20photography&width=600&height=800&seq=actor-c05&orientation=portrait",
    role: "演员",
    bio: "年代剧与情感题材代表演员，表演自然真挚。",
    intro: [
      "温屿，演员。常出现在年代与家庭题材作品中，表演自然真挚，富有生活气息。",
      "她与筱田优在《春山可望》《归途列车》中塑造了令人动容的人物关系。",
    ],
    workIds: ["w4", "w6"],
    relatedNewsIds: ["n5"],
  },
  {
    id: "a6",
    name: "顾清和",
    photo:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20calm%20young%20Asian%20man%20with%20soft%20expression%2C%20muted%20indigo%20background%20with%20warm%20amber%20edge%20light%2C%20minimal%20editorial%20celebrity%20photography&width=600&height=800&seq=actor-c06&orientation=portrait",
    role: "演员",
    bio: "都市情感题材演员，气质温和，擅长细腻的情感表达。",
    intro: [
      "顾清和，演员。以都市情感题材作品为主，气质温和，善于在细节中传递情绪。",
      "他在《归途列车》等作品中的表现获得了观众的认可。",
    ],
    workIds: ["w4", "w6"],
    relatedNewsIds: ["n9"],
  },
  {
    id: "a7",
    name: "叶知秋",
    photo:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20serene%20young%20Asian%20woman%20with%20deep%20calm%20eyes%2C%20teal%20indigo%20underwater%20toned%20background%2C%20soft%20light%20rays%2C%20artistic%20editorial%20celebrity%20photography&width=600&height=800&seq=actor-c07&orientation=portrait",
    role: "演员",
    bio: "气质独特，涉猎科幻与文艺题材，表演富有想象力。",
    intro: [
      "叶知秋，演员。气质独特，作品涵盖科幻与文艺题材，表演富有想象力与质感。",
      "在《深海回响》中，她与筱田优共同构建了一个关于记忆与海洋的世界。",
    ],
    workIds: ["w5"],
    relatedNewsIds: ["n8"],
  },
  {
    id: "a8",
    name: "陈屿",
    photo:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20focused%20Asian%20man%20in%20his%20thirties%20with%20director%20demeanor%2C%20dark%20indigo%20studio%20background%20with%20warm%20side%20light%2C%20cinematic%20editorial%20photography&width=600&height=800&seq=actor-c08&orientation=portrait",
    role: "导演 / 编剧",
    bio: "与筱田优长期合作的核心创作者，作品以冷峻影像与扎实叙事著称。",
    intro: [
      "陈屿，导演、编剧。与筱田优长期合作，共同完成了《无声告白》《长夜将尽》《光年之外》等作品。",
      "他的作品以冷峻的影像风格与扎实的叙事结构著称，注重人物内心的真实刻画。",
    ],
    workIds: ["w1", "w3", "w7"],
    relatedNewsIds: ["n1", "n2", "n4"],
  },
];